var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.838 74.465c18.115 0 32.8-14.686 32.8-32.8 0-18.115-14.685-32.8-32.8-32.8-18.115 0-32.8 14.685-32.8 32.8 0 18.114 14.685 32.8 32.8 32.8Z",
    fill: "#2F5EA7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.598,
    cy: 38.487,
    r: 32.779,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m34.906 52.43-12.35-12.639a1.977 1.977 0 0 1 0-2.75l2.687-2.75a1.87 1.87 0 0 1 2.687 0l8.32 8.515L54.07 24.57a1.87 1.87 0 0 1 2.687 0l2.687 2.75c.741.759.741 1.99 0 2.75l-21.85 22.36a1.87 1.87 0 0 1-2.688 0Z",
    fill: "#2F5EA7"
  })));
};
export default SvgSuccess;